import { PctHttpErrorResponse } from '../../pct-http-error-response';

export class MaintenanceModeError extends PctHttpErrorResponse {
  constructor(
    message: string,
    status: number,
    response: string,
    headers: {
      [key: string]: any;
    },
    originalError?: Error,
  ) {
    super(message, status, response, headers, originalError);
  }
}
